export const CLEANS_STATUSES: any = {
  no: {
    label: "не принята",
    color: "magenta",
  },
  accept: {
    label: "принята",
    color: "blue",
  },
  refusal: {
    label: "отказ",
    color: "magenta",
  },
  start: {
    label: "начата",
    color: "green",
  },
  finish_without_photo: {
    label: 'выполнена (без фото)',
    color: 'green'
  },
  finish: {
    label: "выполнена",
    color: "gray",
  },
};

export type DrawerType = "clean" | "code" | "comment" | "instruction" | "buy" | "fix" | "finish" | "theory" | "howin" | "refuse" | 'meters' | 'upload' ;

export interface IObject {
  id: number;
  name: string;
  address: string;
  desc: string;
  point: string;
  checkin: string;
  checkout: string;
  deposit: number;
  active: boolean;
  loaded: boolean;
  keylock: boolean;
  curkey: string;
  instructions?: boolean;
  wifi?: string | null;
  category: string;
  meters_requested: boolean;
}

interface IRent {
  id: number;
  notes?: string;
  guests: number;
  adults: number;
  children: number;
  plan_in: string | null;
  plan_out: string | null;
  has_out?: boolean;
}

export interface ICleanMessage {
  id: string;
  name: string;
  clean_id: number;
  author: string;
  text: string;
  createdAt: string;
  files?: any;
}

export interface IClean {
  id: number;
  cleaner_id: string | null;
  rent_id?: number;
  object_id: number;
  type: string;
  comment: string;
  status: string;
  cost: number;
  date: string;
  plan_time?: string;
  cleantime?: string;
  rent?: IRent;
  rentAfter?: IRent;
  object: IObject;
  object_state?: ICleanObjectState;
  object_state_comment?: string;
  rate: number | null;
  clean_messages?: ICleanMessage[];
}

export type ICleanObjectState = "good" | "has_problems";

export const OBJECT_STATES: Record<ICleanObjectState | string, string> = {
  good: "всё в порядке",
  has_problems: "есть проблемы",
};

export const HEAVY_FILE_TEXT = "Чтобы видео загружалось быстрее, снизьте его качество в настройках телефона.\nДля этого выберите разрешение 720p в настройках видео."
